// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file luwu/v1/ctl.proto (package luwu.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { HostInfo } from "./auth_pb";
import { file_luwu_v1_auth } from "./auth_pb";
import type { Error } from "./common_pb";
import { file_luwu_v1_common } from "./common_pb";
import type { ForwardPort } from "./forward_pb";
import { file_luwu_v1_forward } from "./forward_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file luwu/v1/ctl.proto.
 */
export const file_luwu_v1_ctl: GenFile = /*@__PURE__*/
  fileDesc("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", [file_luwu_v1_auth, file_luwu_v1_common, file_luwu_v1_forward]);

/**
 * @generated from message luwu.v1.Agent
 */
export type Agent = Message<"luwu.v1.Agent"> & {
  /**
   * @generated from field: luwu.v1.AgentKind kind = 1;
   */
  kind: AgentKind;

  /**
   * @generated from field: luwu.v1.AgentState state = 2;
   */
  state: AgentState;

  /**
   * @generated from field: int64 since_ms = 3;
   */
  sinceMs: bigint;

  /**
   * @generated from field: string detail = 4;
   */
  detail: string;

  /**
   * @generated from field: float confidence = 5;
   */
  confidence: number;
};

/**
 * Describes the message luwu.v1.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema: GenMessage<Agent> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 0);

/**
 * @generated from message luwu.v1.Pane
 */
export type Pane = Message<"luwu.v1.Pane"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string command = 2;
   */
  command: string;

  /**
   * @generated from field: string cwd = 3;
   */
  cwd: string;

  /**
   * @generated from field: uint32 cols = 4;
   */
  cols: number;

  /**
   * @generated from field: uint32 rows = 5;
   */
  rows: number;

  /**
   * @generated from field: bool active = 6;
   */
  active: boolean;

  /**
   * @generated from field: luwu.v1.Agent agent = 7;
   */
  agent?: Agent | undefined;

  /**
   * The last command run in this pane, with shell integration on
   * (go/internal/shellmark): its text and exit code.
   *
   * @generated from field: luwu.v1.LastCommand last = 8;
   */
  last?: LastCommand | undefined;
};

/**
 * Describes the message luwu.v1.Pane.
 * Use `create(PaneSchema)` to create a new message.
 */
export const PaneSchema: GenMessage<Pane> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 1);

/**
 * @generated from message luwu.v1.LastCommand
 */
export type LastCommand = Message<"luwu.v1.LastCommand"> & {
  /**
   * @generated from field: string command = 1;
   */
  command: string;

  /**
   * @generated from field: int32 exit_code = 2;
   */
  exitCode: number;

  /**
   * @generated from field: int64 finished_ms = 3;
   */
  finishedMs: bigint;

  /**
   * only in GetLastCommand's reply
   *
   * @generated from field: string output = 4;
   */
  output: string;
};

/**
 * Describes the message luwu.v1.LastCommand.
 * Use `create(LastCommandSchema)` to create a new message.
 */
export const LastCommandSchema: GenMessage<LastCommand> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 2);

/**
 * Continue an agent that runs outside tmux (a plain iTerm or Terminal tab),
 * which a phone can't reach: the computer opens a tmux session in the
 * agent's folder resuming a copy of its conversation (claude --resume
 * --fork-session). ref is the one the computer put in the notification; the
 * computer only resumes conversations its own hooks reported. Answers a
 * Session with the new window.
 *
 * @generated from message luwu.v1.ResumeAgent
 */
export type ResumeAgent = Message<"luwu.v1.ResumeAgent"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;
};

/**
 * Describes the message luwu.v1.ResumeAgent.
 * Use `create(ResumeAgentSchema)` to create a new message.
 */
export const ResumeAgentSchema: GenMessage<ResumeAgent> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 3);

/**
 * The last command in a window's active pane, with its output.
 *
 * @generated from message luwu.v1.GetLastCommand
 */
export type GetLastCommand = Message<"luwu.v1.GetLastCommand"> & {
  /**
   * @generated from field: string window_id = 1;
   */
  windowId: string;

  /**
   * or a pane
   *
   * @generated from field: string pane_id = 2;
   */
  paneId: string;
};

/**
 * Describes the message luwu.v1.GetLastCommand.
 * Use `create(GetLastCommandSchema)` to create a new message.
 */
export const GetLastCommandSchema: GenMessage<GetLastCommand> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 4);

/**
 * @generated from message luwu.v1.Window
 */
export type Window = Message<"luwu.v1.Window"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: uint32 index = 2;
   */
  index: number;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: bool active = 4;
   */
  active: boolean;

  /**
   * @generated from field: repeated luwu.v1.Pane panes = 5;
   */
  panes: Pane[];
};

/**
 * Describes the message luwu.v1.Window.
 * Use `create(WindowSchema)` to create a new message.
 */
export const WindowSchema: GenMessage<Window> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 5);

/**
 * @generated from message luwu.v1.Session
 */
export type Session = Message<"luwu.v1.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool attached = 3;
   */
  attached: boolean;

  /**
   * @generated from field: repeated luwu.v1.Window windows = 4;
   */
  windows: Window[];
};

/**
 * Describes the message luwu.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 6);

/**
 * @generated from message luwu.v1.Ping
 */
export type Ping = Message<"luwu.v1.Ping"> & {
  /**
   * @generated from field: int64 sent_ms = 1;
   */
  sentMs: bigint;
};

/**
 * Describes the message luwu.v1.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 7);

/**
 * @generated from message luwu.v1.Pong
 */
export type Pong = Message<"luwu.v1.Pong"> & {
  /**
   * @generated from field: int64 sent_ms = 1;
   */
  sentMs: bigint;

  /**
   * @generated from field: int64 host_ms = 2;
   */
  hostMs: bigint;
};

/**
 * Describes the message luwu.v1.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 8);

/**
 * @generated from message luwu.v1.ListSessions
 */
export type ListSessions = Message<"luwu.v1.ListSessions"> & {
};

/**
 * Describes the message luwu.v1.ListSessions.
 * Use `create(ListSessionsSchema)` to create a new message.
 */
export const ListSessionsSchema: GenMessage<ListSessions> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 9);

/**
 * @generated from message luwu.v1.SessionList
 */
export type SessionList = Message<"luwu.v1.SessionList"> & {
  /**
   * @generated from field: repeated luwu.v1.Session sessions = 1;
   */
  sessions: Session[];
};

/**
 * Describes the message luwu.v1.SessionList.
 * Use `create(SessionListSchema)` to create a new message.
 */
export const SessionListSchema: GenMessage<SessionList> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 10);

/**
 * @generated from message luwu.v1.CreateWindow
 */
export type CreateWindow = Message<"luwu.v1.CreateWindow"> & {
  /**
   * empty = "luwu"
   *
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * claude, codex, shell, ...
   *
   * @generated from field: string preset = 2;
   */
  preset: string;

  /**
   * @generated from field: string cwd = 3;
   */
  cwd: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * A task to start the preset with (written on a phone). The computer
   * hands it to the agent as one argument (go/internal/presets); older
   * computers ignore it and start the preset without it.
   *
   * @generated from field: string prompt = 5;
   */
  prompt: string;
};

/**
 * Describes the message luwu.v1.CreateWindow.
 * Use `create(CreateWindowSchema)` to create a new message.
 */
export const CreateWindowSchema: GenMessage<CreateWindow> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 11);

/**
 * @generated from message luwu.v1.KillWindow
 */
export type KillWindow = Message<"luwu.v1.KillWindow"> & {
  /**
   * @generated from field: string window_id = 1;
   */
  windowId: string;
};

/**
 * Describes the message luwu.v1.KillWindow.
 * Use `create(KillWindowSchema)` to create a new message.
 */
export const KillWindowSchema: GenMessage<KillWindow> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 12);

/**
 * KillSession ends a whole session ("$3" or a name) and everything running
 * in it, like `tmux kill-session`.
 *
 * @generated from message luwu.v1.KillSession
 */
export type KillSession = Message<"luwu.v1.KillSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message luwu.v1.KillSession.
 * Use `create(KillSessionSchema)` to create a new message.
 */
export const KillSessionSchema: GenMessage<KillSession> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 13);

/**
 * @generated from message luwu.v1.RenameWindow
 */
export type RenameWindow = Message<"luwu.v1.RenameWindow"> & {
  /**
   * @generated from field: string window_id = 1;
   */
  windowId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message luwu.v1.RenameWindow.
 * Use `create(RenameWindowSchema)` to create a new message.
 */
export const RenameWindowSchema: GenMessage<RenameWindow> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 14);

/**
 * @generated from message luwu.v1.RenameSession
 */
export type RenameSession = Message<"luwu.v1.RenameSession"> & {
  /**
   * "$3" or a name
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message luwu.v1.RenameSession.
 * Use `create(RenameSessionSchema)` to create a new message.
 */
export const RenameSessionSchema: GenMessage<RenameSession> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 15);

/**
 * @generated from message luwu.v1.Subscribe
 */
export type Subscribe = Message<"luwu.v1.Subscribe"> & {
};

/**
 * Describes the message luwu.v1.Subscribe.
 * Use `create(SubscribeSchema)` to create a new message.
 */
export const SubscribeSchema: GenMessage<Subscribe> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 16);

/**
 * @generated from message luwu.v1.GetHostInfo
 */
export type GetHostInfo = Message<"luwu.v1.GetHostInfo"> & {
};

/**
 * Describes the message luwu.v1.GetHostInfo.
 * Use `create(GetHostInfoSchema)` to create a new message.
 */
export const GetHostInfoSchema: GenMessage<GetHostInfo> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 17);

/**
 * @generated from message luwu.v1.DeviceEntry
 */
export type DeviceEntry = Message<"luwu.v1.DeviceEntry"> & {
  /**
   * @generated from field: string peer_id = 1;
   */
  peerId: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string platform = 4;
   */
  platform: string;

  /**
   * @generated from field: bool trusted = 5;
   */
  trusted: boolean;

  /**
   * @generated from field: bool pending = 6;
   */
  pending: boolean;

  /**
   * @generated from field: int64 last_seen_ms = 7;
   */
  lastSeenMs: bigint;
};

/**
 * Describes the message luwu.v1.DeviceEntry.
 * Use `create(DeviceEntrySchema)` to create a new message.
 */
export const DeviceEntrySchema: GenMessage<DeviceEntry> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 18);

/**
 * @generated from message luwu.v1.ListDevices
 */
export type ListDevices = Message<"luwu.v1.ListDevices"> & {
};

/**
 * Describes the message luwu.v1.ListDevices.
 * Use `create(ListDevicesSchema)` to create a new message.
 */
export const ListDevicesSchema: GenMessage<ListDevices> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 19);

/**
 * @generated from message luwu.v1.DeviceList
 */
export type DeviceList = Message<"luwu.v1.DeviceList"> & {
  /**
   * @generated from field: repeated luwu.v1.DeviceEntry devices = 1;
   */
  devices: DeviceEntry[];
};

/**
 * Describes the message luwu.v1.DeviceList.
 * Use `create(DeviceListSchema)` to create a new message.
 */
export const DeviceListSchema: GenMessage<DeviceList> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 20);

/**
 * @generated from message luwu.v1.ApproveDevice
 */
export type ApproveDevice = Message<"luwu.v1.ApproveDevice"> & {
  /**
   * @generated from field: string peer_id = 1;
   */
  peerId: string;

  /**
   * @generated from field: bool approve = 2;
   */
  approve: boolean;
};

/**
 * Describes the message luwu.v1.ApproveDevice.
 * Use `create(ApproveDeviceSchema)` to create a new message.
 */
export const ApproveDeviceSchema: GenMessage<ApproveDevice> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 21);

/**
 * @generated from message luwu.v1.Empty
 */
export type Empty = Message<"luwu.v1.Empty"> & {
};

/**
 * Describes the message luwu.v1.Empty.
 * Use `create(EmptySchema)` to create a new message.
 */
export const EmptySchema: GenMessage<Empty> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 22);

/**
 * Guests in shared windows, for the owner's devices.
 *
 * @generated from message luwu.v1.ListGuests
 */
export type ListGuests = Message<"luwu.v1.ListGuests"> & {
};

/**
 * Describes the message luwu.v1.ListGuests.
 * Use `create(ListGuestsSchema)` to create a new message.
 */
export const ListGuestsSchema: GenMessage<ListGuests> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 23);

/**
 * @generated from message luwu.v1.Guest
 */
export type Guest = Message<"luwu.v1.Guest"> & {
  /**
   * @generated from field: string peer_id = 1;
   */
  peerId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string share_id = 3;
   */
  shareId: string;

  /**
   * @generated from field: string window_id = 4;
   */
  windowId: string;

  /**
   * @generated from field: bool can_type = 5;
   */
  canType: boolean;

  /**
   * @generated from field: int64 since_ms = 6;
   */
  sinceMs: bigint;

  /**
   * unix seconds
   *
   * @generated from field: int64 expires_at = 7;
   */
  expiresAt: bigint;
};

/**
 * Describes the message luwu.v1.Guest.
 * Use `create(GuestSchema)` to create a new message.
 */
export const GuestSchema: GenMessage<Guest> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 24);

/**
 * The ports this computer forwards (Stage 1.5), for the owner's devices.
 *
 * @generated from message luwu.v1.ListForwards
 */
export type ListForwards = Message<"luwu.v1.ListForwards"> & {
};

/**
 * Describes the message luwu.v1.ListForwards.
 * Use `create(ListForwardsSchema)` to create a new message.
 */
export const ListForwardsSchema: GenMessage<ListForwards> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 25);

/**
 * Types into one tmux pane, e.g. answering an agent from a notification:
 * text typed literally, then an optional key (Enter, Escape, …).
 *
 * @generated from message luwu.v1.SendKeys
 */
export type SendKeys = Message<"luwu.v1.SendKeys"> & {
  /**
   * "%3"
   *
   * @generated from field: string pane_id = 1;
   */
  paneId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * "", "Enter", "Escape", "Up", "Down", "Tab"
   *
   * @generated from field: string key = 3;
   */
  key: string;
};

/**
 * Describes the message luwu.v1.SendKeys.
 * Use `create(SendKeysSchema)` to create a new message.
 */
export const SendKeysSchema: GenMessage<SendKeys> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 26);

/**
 * Answers the agent from a notification: the computer checks the one-time
 * ask the notification carried and types the answer itself.
 *
 * @generated from message luwu.v1.AnswerAgent
 */
export type AnswerAgent = Message<"luwu.v1.AnswerAgent"> & {
  /**
   * @generated from field: string ask_id = 1;
   */
  askId: string;

  /**
   * c1..c4 | allow | deny | reply (text) | other (text: "Type something")
   * | form (text: JSON, agent.FormAnswer)
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message luwu.v1.AnswerAgent.
 * Use `create(AnswerAgentSchema)` to create a new message.
 */
export const AnswerAgentSchema: GenMessage<AnswerAgent> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 27);

/**
 * Updates the computer's luwu to the latest release (or version), then
 * restarts it. The account's own devices only.
 *
 * @generated from message luwu.v1.UpdateHost
 */
export type UpdateHost = Message<"luwu.v1.UpdateHost"> & {
  /**
   * "" = latest
   *
   * @generated from field: string version = 1;
   */
  version: string;
};

/**
 * Describes the message luwu.v1.UpdateHost.
 * Use `create(UpdateHostSchema)` to create a new message.
 */
export const UpdateHostSchema: GenMessage<UpdateHost> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 28);

/**
 * @generated from message luwu.v1.UpdateResult
 */
export type UpdateResult = Message<"luwu.v1.UpdateResult"> & {
  /**
   * the version it's updating to, or running
   *
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: bool up_to_date = 2;
   */
  upToDate: boolean;
};

/**
 * Describes the message luwu.v1.UpdateResult.
 * Use `create(UpdateResultSchema)` to create a new message.
 */
export const UpdateResultSchema: GenMessage<UpdateResult> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 29);

/**
 * Agent mode (go/internal/agentrun): runs the computer drives through the
 * agent's structured protocol. Their transcripts stream over
 * /luwu/agent/1.0.0.
 *
 * @generated from message luwu.v1.ListAgentRuns
 */
export type ListAgentRuns = Message<"luwu.v1.ListAgentRuns"> & {
};

/**
 * Describes the message luwu.v1.ListAgentRuns.
 * Use `create(ListAgentRunsSchema)` to create a new message.
 */
export const ListAgentRunsSchema: GenMessage<ListAgentRuns> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 30);

/**
 * @generated from message luwu.v1.AgentRun
 */
export type AgentRun = Message<"luwu.v1.AgentRun"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * claude
   *
   * @generated from field: string agent = 2;
   */
  agent: string;

  /**
   * @generated from field: string cwd = 3;
   */
  cwd: string;

  /**
   * the first prompt, shortened
   *
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string model = 5;
   */
  model: string;

  /**
   * working | idle | waiting | exited | starting
   *
   * @generated from field: string state = 6;
   */
  state: string;

  /**
   * @generated from field: int64 created_ms = 7;
   */
  createdMs: bigint;

  /**
   * @generated from field: int64 updated_ms = 8;
   */
  updatedMs: bigint;

  /**
   * its tmux window
   *
   * @generated from field: string window_id = 9;
   */
  windowId: string;

  /**
   * its process is running
   *
   * @generated from field: bool live = 10;
   */
  live: boolean;

  /**
   * the preset it was started with (deepseek), when not the agent itself
   *
   * @generated from field: string preset = 11;
   */
  preset: string;
};

/**
 * Describes the message luwu.v1.AgentRun.
 * Use `create(AgentRunSchema)` to create a new message.
 */
export const AgentRunSchema: GenMessage<AgentRun> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 31);

/**
 * @generated from message luwu.v1.AgentRunList
 */
export type AgentRunList = Message<"luwu.v1.AgentRunList"> & {
  /**
   * @generated from field: repeated luwu.v1.AgentRun runs = 1;
   */
  runs: AgentRun[];
};

/**
 * Describes the message luwu.v1.AgentRunList.
 * Use `create(AgentRunListSchema)` to create a new message.
 */
export const AgentRunListSchema: GenMessage<AgentRunList> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 32);

/**
 * Starts a run in a new tmux window of the "agents" session.
 *
 * @generated from message luwu.v1.StartAgentRun
 */
export type StartAgentRun = Message<"luwu.v1.StartAgentRun"> & {
  /**
   * claude, codex, or a preset based on one (deepseek: HostInfo.agents)
   *
   * @generated from field: string agent = 1;
   */
  agent: string;

  /**
   * "~/code/shop-api"; "" = home
   *
   * @generated from field: string cwd = 2;
   */
  cwd: string;

  /**
   * the first prompt
   *
   * @generated from field: string prompt = 3;
   */
  prompt: string;

  /**
   * "" = the agent's default
   *
   * @generated from field: string model = 4;
   */
  model: string;
};

/**
 * Describes the message luwu.v1.StartAgentRun.
 * Use `create(StartAgentRunSchema)` to create a new message.
 */
export const StartAgentRunSchema: GenMessage<StartAgentRun> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 33);

/**
 * Answers a run's tool approval from a notification (allow or deny).
 *
 * @generated from message luwu.v1.AnswerAgentRun
 */
export type AnswerAgentRun = Message<"luwu.v1.AnswerAgentRun"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string approval_id = 2;
   */
  approvalId: string;

  /**
   * @generated from field: bool allow = 3;
   */
  allow: boolean;
};

/**
 * Describes the message luwu.v1.AnswerAgentRun.
 * Use `create(AnswerAgentRunSchema)` to create a new message.
 */
export const AnswerAgentRunSchema: GenMessage<AnswerAgentRun> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 34);

/**
 * What an ask asks, for answering it in the app.
 *
 * @generated from message luwu.v1.GetAsk
 */
export type GetAsk = Message<"luwu.v1.GetAsk"> & {
  /**
   * @generated from field: string ask_id = 1;
   */
  askId: string;
};

/**
 * Describes the message luwu.v1.GetAsk.
 * Use `create(GetAskSchema)` to create a new message.
 */
export const GetAskSchema: GenMessage<GetAsk> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 35);

/**
 * @generated from message luwu.v1.AskInfo
 */
export type AskInfo = Message<"luwu.v1.AskInfo"> & {
  /**
   * the ask's kind: choice2..4 | permission | reply | question | plan
   *
   * @generated from field: string reply = 1;
   */
  reply: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * the tool's input: {"questions": […]} or {"plan": "…"}
   *
   * @generated from field: string input_json = 3;
   */
  inputJson: string;

  /**
   * the menu on screen now (plans)
   *
   * @generated from field: repeated luwu.v1.MenuRow menu = 4;
   */
  menu: MenuRow[];

  /**
   * @generated from field: string agent = 5;
   */
  agent: string;
};

/**
 * Describes the message luwu.v1.AskInfo.
 * Use `create(AskInfoSchema)` to create a new message.
 */
export const AskInfoSchema: GenMessage<AskInfo> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 36);

/**
 * @generated from message luwu.v1.MenuRow
 */
export type MenuRow = Message<"luwu.v1.MenuRow"> & {
  /**
   * @generated from field: int32 n = 1;
   */
  n: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * takes text ("Tell Claude what to change")
   *
   * @generated from field: bool typed = 3;
   */
  typed: boolean;
};

/**
 * Describes the message luwu.v1.MenuRow.
 * Use `create(MenuRowSchema)` to create a new message.
 */
export const MenuRowSchema: GenMessage<MenuRow> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 37);

/**
 * @generated from message luwu.v1.ForwardList
 */
export type ForwardList = Message<"luwu.v1.ForwardList"> & {
  /**
   * @generated from field: repeated luwu.v1.ForwardPort ports = 1;
   */
  ports: ForwardPort[];

  /**
   * Ports this computer's user listens on locally that aren't allowed yet
   * (a dev server just started), for allowing on the computer.
   *
   * @generated from field: repeated luwu.v1.ForwardPort suggested = 2;
   */
  suggested: ForwardPort[];
};

/**
 * Describes the message luwu.v1.ForwardList.
 * Use `create(ForwardListSchema)` to create a new message.
 */
export const ForwardListSchema: GenMessage<ForwardList> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 38);

/**
 * @generated from message luwu.v1.GuestList
 */
export type GuestList = Message<"luwu.v1.GuestList"> & {
  /**
   * @generated from field: repeated luwu.v1.Guest guests = 1;
   */
  guests: Guest[];
};

/**
 * Describes the message luwu.v1.GuestList.
 * Use `create(GuestListSchema)` to create a new message.
 */
export const GuestListSchema: GenMessage<GuestList> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 39);

/**
 * EndShare disconnects a share's guests (or one guest) at once and refuses them until the
 * share would have expired (the control plane's CRL catches up later).
 *
 * @generated from message luwu.v1.EndShare
 */
export type EndShare = Message<"luwu.v1.EndShare"> & {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId: string;

  /**
   * unix seconds; how long to remember it
   *
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt: bigint;

  /**
   * set: remove only this guest; the share stays open
   *
   * @generated from field: string peer_id = 3;
   */
  peerId: string;
};

/**
 * Describes the message luwu.v1.EndShare.
 * Use `create(EndShareSchema)` to create a new message.
 */
export const EndShareSchema: GenMessage<EndShare> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 40);

/**
 * @generated from message luwu.v1.CtlRequest
 */
export type CtlRequest = Message<"luwu.v1.CtlRequest"> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from oneof luwu.v1.CtlRequest.req
   */
  req: {
    /**
     * @generated from field: luwu.v1.Ping ping = 10;
     */
    value: Ping;
    case: "ping";
  } | {
    /**
     * @generated from field: luwu.v1.ListSessions list_sessions = 11;
     */
    value: ListSessions;
    case: "listSessions";
  } | {
    /**
     * @generated from field: luwu.v1.CreateWindow create_window = 12;
     */
    value: CreateWindow;
    case: "createWindow";
  } | {
    /**
     * @generated from field: luwu.v1.KillWindow kill_window = 13;
     */
    value: KillWindow;
    case: "killWindow";
  } | {
    /**
     * @generated from field: luwu.v1.RenameWindow rename_window = 14;
     */
    value: RenameWindow;
    case: "renameWindow";
  } | {
    /**
     * @generated from field: luwu.v1.Subscribe subscribe = 15;
     */
    value: Subscribe;
    case: "subscribe";
  } | {
    /**
     * @generated from field: luwu.v1.GetHostInfo host_info = 16;
     */
    value: GetHostInfo;
    case: "hostInfo";
  } | {
    /**
     * @generated from field: luwu.v1.ListDevices list_devices = 17;
     */
    value: ListDevices;
    case: "listDevices";
  } | {
    /**
     * @generated from field: luwu.v1.ApproveDevice approve_device = 18;
     */
    value: ApproveDevice;
    case: "approveDevice";
  } | {
    /**
     * @generated from field: luwu.v1.RenameSession rename_session = 19;
     */
    value: RenameSession;
    case: "renameSession";
  } | {
    /**
     * @generated from field: luwu.v1.ListGuests list_guests = 20;
     */
    value: ListGuests;
    case: "listGuests";
  } | {
    /**
     * @generated from field: luwu.v1.EndShare end_share = 21;
     */
    value: EndShare;
    case: "endShare";
  } | {
    /**
     * @generated from field: luwu.v1.ListForwards list_forwards = 22;
     */
    value: ListForwards;
    case: "listForwards";
  } | {
    /**
     * @generated from field: luwu.v1.SendKeys send_keys = 23;
     */
    value: SendKeys;
    case: "sendKeys";
  } | {
    /**
     * @generated from field: luwu.v1.AnswerAgent answer_agent = 24;
     */
    value: AnswerAgent;
    case: "answerAgent";
  } | {
    /**
     * @generated from field: luwu.v1.GetAsk get_ask = 25;
     */
    value: GetAsk;
    case: "getAsk";
  } | {
    /**
     * @generated from field: luwu.v1.UpdateHost update_host = 26;
     */
    value: UpdateHost;
    case: "updateHost";
  } | {
    /**
     * @generated from field: luwu.v1.ListAgentRuns list_agent_runs = 27;
     */
    value: ListAgentRuns;
    case: "listAgentRuns";
  } | {
    /**
     * @generated from field: luwu.v1.StartAgentRun start_agent_run = 28;
     */
    value: StartAgentRun;
    case: "startAgentRun";
  } | {
    /**
     * @generated from field: luwu.v1.AnswerAgentRun answer_agent_run = 29;
     */
    value: AnswerAgentRun;
    case: "answerAgentRun";
  } | {
    /**
     * @generated from field: luwu.v1.GetLastCommand get_last_command = 30;
     */
    value: GetLastCommand;
    case: "getLastCommand";
  } | {
    /**
     * @generated from field: luwu.v1.ResumeAgent resume_agent = 31;
     */
    value: ResumeAgent;
    case: "resumeAgent";
  } | {
    /**
     * @generated from field: luwu.v1.KillSession kill_session = 32;
     */
    value: KillSession;
    case: "killSession";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message luwu.v1.CtlRequest.
 * Use `create(CtlRequestSchema)` to create a new message.
 */
export const CtlRequestSchema: GenMessage<CtlRequest> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 41);

/**
 * @generated from message luwu.v1.CtlResponse
 */
export type CtlResponse = Message<"luwu.v1.CtlResponse"> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: luwu.v1.Error error = 2;
   */
  error?: Error | undefined;

  /**
   * @generated from oneof luwu.v1.CtlResponse.resp
   */
  resp: {
    /**
     * @generated from field: luwu.v1.Pong pong = 10;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * @generated from field: luwu.v1.SessionList sessions = 11;
     */
    value: SessionList;
    case: "sessions";
  } | {
    /**
     * @generated from field: luwu.v1.Window window = 12;
     */
    value: Window;
    case: "window";
  } | {
    /**
     * @generated from field: luwu.v1.HostInfo host = 13;
     */
    value: HostInfo;
    case: "host";
  } | {
    /**
     * @generated from field: luwu.v1.DeviceList devices = 14;
     */
    value: DeviceList;
    case: "devices";
  } | {
    /**
     * @generated from field: luwu.v1.Empty empty = 15;
     */
    value: Empty;
    case: "empty";
  } | {
    /**
     * @generated from field: luwu.v1.GuestList guests = 16;
     */
    value: GuestList;
    case: "guests";
  } | {
    /**
     * @generated from field: luwu.v1.ForwardList forwards = 17;
     */
    value: ForwardList;
    case: "forwards";
  } | {
    /**
     * @generated from field: luwu.v1.AskInfo ask = 18;
     */
    value: AskInfo;
    case: "ask";
  } | {
    /**
     * @generated from field: luwu.v1.UpdateResult update = 19;
     */
    value: UpdateResult;
    case: "update";
  } | {
    /**
     * @generated from field: luwu.v1.AgentRunList agent_runs = 20;
     */
    value: AgentRunList;
    case: "agentRuns";
  } | {
    /**
     * @generated from field: luwu.v1.AgentRun agent_run = 21;
     */
    value: AgentRun;
    case: "agentRun";
  } | {
    /**
     * @generated from field: luwu.v1.LastCommand last_command = 22;
     */
    value: LastCommand;
    case: "lastCommand";
  } | {
    /**
     * @generated from field: luwu.v1.Session session = 23;
     */
    value: Session;
    case: "session";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message luwu.v1.CtlResponse.
 * Use `create(CtlResponseSchema)` to create a new message.
 */
export const CtlResponseSchema: GenMessage<CtlResponse> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 42);

/**
 * @generated from message luwu.v1.WindowEvent
 */
export type WindowEvent = Message<"luwu.v1.WindowEvent"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: luwu.v1.Window window = 2;
   */
  window?: Window | undefined;
};

/**
 * Describes the message luwu.v1.WindowEvent.
 * Use `create(WindowEventSchema)` to create a new message.
 */
export const WindowEventSchema: GenMessage<WindowEvent> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 43);

/**
 * @generated from message luwu.v1.AgentStateChanged
 */
export type AgentStateChanged = Message<"luwu.v1.AgentStateChanged"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string window_id = 2;
   */
  windowId: string;

  /**
   * @generated from field: string pane_id = 3;
   */
  paneId: string;

  /**
   * @generated from field: luwu.v1.Agent agent = 4;
   */
  agent?: Agent | undefined;
};

/**
 * Describes the message luwu.v1.AgentStateChanged.
 * Use `create(AgentStateChangedSchema)` to create a new message.
 */
export const AgentStateChangedSchema: GenMessage<AgentStateChanged> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 44);

/**
 * @generated from message luwu.v1.Bell
 */
export type Bell = Message<"luwu.v1.Bell"> & {
  /**
   * @generated from field: string window_id = 1;
   */
  windowId: string;
};

/**
 * Describes the message luwu.v1.Bell.
 * Use `create(BellSchema)` to create a new message.
 */
export const BellSchema: GenMessage<Bell> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 45);

/**
 * @generated from message luwu.v1.CrlUpdated
 */
export type CrlUpdated = Message<"luwu.v1.CrlUpdated"> & {
  /**
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;
};

/**
 * Describes the message luwu.v1.CrlUpdated.
 * Use `create(CrlUpdatedSchema)` to create a new message.
 */
export const CrlUpdatedSchema: GenMessage<CrlUpdated> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 46);

/**
 * @generated from message luwu.v1.HostShutdown
 */
export type HostShutdown = Message<"luwu.v1.HostShutdown"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message luwu.v1.HostShutdown.
 * Use `create(HostShutdownSchema)` to create a new message.
 */
export const HostShutdownSchema: GenMessage<HostShutdown> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 47);

/**
 * @generated from message luwu.v1.CtlEvent
 */
export type CtlEvent = Message<"luwu.v1.CtlEvent"> & {
  /**
   * @generated from oneof luwu.v1.CtlEvent.ev
   */
  ev: {
    /**
     * @generated from field: luwu.v1.WindowEvent window_added = 1;
     */
    value: WindowEvent;
    case: "windowAdded";
  } | {
    /**
     * @generated from field: luwu.v1.WindowEvent window_closed = 2;
     */
    value: WindowEvent;
    case: "windowClosed";
  } | {
    /**
     * @generated from field: luwu.v1.WindowEvent window_renamed = 3;
     */
    value: WindowEvent;
    case: "windowRenamed";
  } | {
    /**
     * @generated from field: luwu.v1.AgentStateChanged agent_state = 4;
     */
    value: AgentStateChanged;
    case: "agentState";
  } | {
    /**
     * @generated from field: luwu.v1.Bell bell = 5;
     */
    value: Bell;
    case: "bell";
  } | {
    /**
     * @generated from field: luwu.v1.CrlUpdated crl = 6;
     */
    value: CrlUpdated;
    case: "crl";
  } | {
    /**
     * @generated from field: luwu.v1.HostShutdown shutdown = 7;
     */
    value: HostShutdown;
    case: "shutdown";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message luwu.v1.CtlEvent.
 * Use `create(CtlEventSchema)` to create a new message.
 */
export const CtlEventSchema: GenMessage<CtlEvent> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 48);

/**
 * CtlMessage is the frame type on the ctl stream in both directions.
 *
 * @generated from message luwu.v1.CtlMessage
 */
export type CtlMessage = Message<"luwu.v1.CtlMessage"> & {
  /**
   * @generated from oneof luwu.v1.CtlMessage.msg
   */
  msg: {
    /**
     * @generated from field: luwu.v1.CtlRequest request = 1;
     */
    value: CtlRequest;
    case: "request";
  } | {
    /**
     * @generated from field: luwu.v1.CtlResponse response = 2;
     */
    value: CtlResponse;
    case: "response";
  } | {
    /**
     * @generated from field: luwu.v1.CtlEvent event = 3;
     */
    value: CtlEvent;
    case: "event";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message luwu.v1.CtlMessage.
 * Use `create(CtlMessageSchema)` to create a new message.
 */
export const CtlMessageSchema: GenMessage<CtlMessage> = /*@__PURE__*/
  messageDesc(file_luwu_v1_ctl, 49);

/**
 * /luwu/ctl/1.0.0 — request/response plus an event subscription.
 *
 * @generated from enum luwu.v1.AgentKind
 */
export enum AgentKind {
  /**
   * @generated from enum value: AGENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_KIND_CLAUDE = 1;
   */
  CLAUDE = 1,

  /**
   * @generated from enum value: AGENT_KIND_CODEX = 2;
   */
  CODEX = 2,

  /**
   * @generated from enum value: AGENT_KIND_GEMINI = 3;
   */
  GEMINI = 3,

  /**
   * @generated from enum value: AGENT_KIND_OPENCODE = 4;
   */
  OPENCODE = 4,

  /**
   * @generated from enum value: AGENT_KIND_OTHER = 15;
   */
  OTHER = 15,
}

/**
 * Describes the enum luwu.v1.AgentKind.
 */
export const AgentKindSchema: GenEnum<AgentKind> = /*@__PURE__*/
  enumDesc(file_luwu_v1_ctl, 0);

/**
 * @generated from enum luwu.v1.AgentState
 */
export enum AgentState {
  /**
   * @generated from enum value: AGENT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_STATE_WORKING = 1;
   */
  WORKING = 1,

  /**
   * @generated from enum value: AGENT_STATE_NEEDS_INPUT = 2;
   */
  NEEDS_INPUT = 2,

  /**
   * @generated from enum value: AGENT_STATE_IDLE = 3;
   */
  IDLE = 3,

  /**
   * @generated from enum value: AGENT_STATE_DONE = 4;
   */
  DONE = 4,

  /**
   * @generated from enum value: AGENT_STATE_ERROR = 5;
   */
  ERROR = 5,
}

/**
 * Describes the enum luwu.v1.AgentState.
 */
export const AgentStateSchema: GenEnum<AgentState> = /*@__PURE__*/
  enumDesc(file_luwu_v1_ctl, 1);

